import { render, staticRenderFns } from "./practice-shaded.vue?vue&type=template&id=184e1ade&"
import script from "./practice-shaded.vue?vue&type=script&lang=js&"
export * from "./practice-shaded.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports